export const webSettingsApi = '/api/v1/common/websettings/';
